import { RecoveryAlianzaComponent } from "./recovery-alianza/recovery-alianza.component";
import { RegisterAlianzaComponent } from "./register-alianza/register-alianza.component";
import { LoginAlianzaComponent } from "./login-alianza/login-alianza.component";
import { RecoveryComponent } from "./recovery/recovery.component";
import { RegisterComponent } from "./register/register.component";
import { LoginComponent } from "./login/login.component";

import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

const routes: Routes = [
  { path: "", component: LoginComponent },
  { path: "login", component: LoginComponent },
  { path: "register", component: RegisterComponent },
  { path: "recover", component: RecoveryComponent },
  { path: "recover/:token", component: RecoveryComponent },
  { path: "login-alianza", component: LoginAlianzaComponent },
  { path: "register-alianza", component: RegisterAlianzaComponent },
  { path: "recover-alianza", component: RecoveryAlianzaComponent },
  { path: "recover-alianza/:renovate", component: RecoveryAlianzaComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
